<template>
  <div class="onadvcard between wrap">
    <div
      v-for="(item, index) in 4"
      :key="index"
      class="onadvca_item marbtm40"
      :class="{ active: ismouse == index }"
      @mouseover=" ismouse = index"
      @mouseout=" ismouse = -1"
    >
      <div v-if="index < 2">
        <div class="info">
          <div class="title"><span>王XX</span>主办律师</div>
          <div class="intro">
            {{
              ` 安徽大学本科毕业，业务精湛，具有深厚的法学理论知识、
            丰富的司法实践经验，成功代理多起影响重大刑事案件`
                | toEllipsisFilter(52)
            }}
          </div>
          <div class="lxdh">
            <svg-icon icon-class="dianhua" class="svgys" /> 188 9555 555
          </div>
          <div class="onzx" v-show="ismouse == index">在线咨询</div>
        </div>
        <div class="law_bg" v-show="ismouse == index">
          <img src="../../../assets/lawyerOnline/ttlaw_sample.png" alt="" />
        </div>
      </div>
      <div v-else>
        <div class="info">
          <div class="title"><span>律师入驻</span>律观网</div>
          <div class="intro">
            {{
              ` 律观网，16年品牌，国内放心的互联网法律服务平台，全国2/3律师的选择，已为全国近5000万公众，提供5600万次法律咨询`
                | toEllipsisFilter(52)
            }}
          </div>
          <div class="rzrs">入驻热线：400-000-0000</div>
          <div class="onzx" v-show="ismouse == index">在线咨询</div>
        </div>
        <div class="law_bg" v-show="ismouse == index">
          <img src="../../../assets/lawyerOnline/qdefa.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    ismouse: 0,
  }),
};
</script>

<style lang="scss" scope>
.onadvcard {
  width: 100%;
  height: 440px;
  font-size: 14px;
  align-items: flex-start;
  .onadvca_item {
    width: 590px;
    height: 200px;
    color: #999999;
    box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.08);
    padding: 45px 30px;
    position: relative;
    .info {
      transition: height 0.3s;
      height: 100%;
      position: relative;
      z-index: 2;
      .title {
        font-size: 16px;
        color: #666666;
        line-height: 20px;
        span {
          font-size: 20px;
          color: #333333;
          margin-right: 14px;
        }
      }
      .intro {
        margin: 13px 0 10px;
        color: #999999;
        line-height: 24px;
      }
      .onzx {
        cursor: pointer;
        width: 90px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border-radius: 5px;
        margin-top: 20px;
        color: #333;
      }
    }
    .law_bg {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 220px;
      }
    }
    &.active {
      transition: all 0.2s;
      height: 220px;
      margin-bottom: 20px;
      .info {
        width: 370px;
        .svgys {
          color: #1375ff;
        }
        .onzx {
          animation: btnanima 0.3s;
        }
      }
    }
  }
  @keyframes btnanima {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }
  .marbtm40 {
    margin-bottom: 40px;
  }
}
</style>